@for (row of data; track row.id) {
  <div class="row align-items-center border-bottom py-2">
    <div class="col-2">{{ row.crossBrand }}</div>
    <div class="col-3 font-weight-bold">{{ row.crossReference }}</div>
    <div class="col-3">{{ row.ottoProductId }}</div>
    <div class="col-2 small text-muted">{{ row.note }}</div>
    <div class="col-2 text-right">
      <button type="button" class="btn btn-sm btn-outline-primary mr-1" (click)="edit(row)">{{ 'EDIT' | translate }}</button>
      <button type="button" class="btn btn-sm btn-outline-danger" (click)="remove(row)">{{ 'DELETE' | translate }}</button>
      @if (deleteFailedId === row.id) {
        <div class="small text-danger">{{ 'DELETE_FAILED' | translate }}</div>
      }
    </div>
  </div>
}
